import {
  Box, Flex, Grid, GridItem, Spinner, Text
} from "@chakra-ui/react";
import { useMemo } from "react";
import FolderHeader from "./HeaderManualReport";
// [FIX] direct imports — lazy() + Suspense causes React #321 with Chakra v2 + React 19
import Folder from "./FolderManualReport";
import File from "./FileManualReport";

const ViewManualReport = ({
  SelectedFolder,
  OnRefetch,
  Height,
  Props = {},
  OnChange,
  OnSelect,
  OnSubmitFolder,
  OnSubmitFile,
  texts = {} 
}) => {
  const {
    FolderData = { Folders: [], Files: [] },
    AllFolders = [], 
    IsFoldersLoading, 
  } = Props;

  const { Folders: subFolders, Files } = FolderData;
  const fileManagerTexts = texts?.fileManager || {};

  const haveContent = useMemo(() => {
    return (subFolders && subFolders.length > 0) || (Files && Files.length > 0);
  }, [subFolders, Files]);

  return (
    <Box
      w={"100%"}
      h={Height}
      border="1px solid"
      borderRadius="md"
      p={0}
      sx={{
        bg: 'var(--fm-view-bg)',
        borderColor: 'var(--fm-view-border)',
        color: 'var(--fm-view-text)'
      }}
    >
      <FolderHeader
        OnChange={OnChange}
        OnRefetch={OnRefetch}
        Selected={SelectedFolder}
        AllFolders={AllFolders}
        texts={texts}
      />
      
      <Box borderTop="1px solid" sx={{ borderColor: 'var(--fm-view-border)' }}>
        {IsFoldersLoading ? (
          <Flex h="calc(100% - 41px)" align="center" justify="center">
            <Spinner sx={{ color: 'var(--Spinner)' }} />
          </Flex>
        ) : (!SelectedFolder && haveContent) || (SelectedFolder && haveContent) ? (
          <Box mt={2}>
            <Grid 
              templateColumns={"repeat(12, 1fr)"} 
              gap={2}
              alignItems={"center"} 
              borderBottomWidth="1px" 
              pb={2} 
              mb={2}
              sx={{ borderColor: 'var(--fm-view-border)' }}
            >
              <GridItem colSpan={{ base: 12, md: 5 }}>
                <Text fontWeight="bold" fontSize="sm" sx={{ color: 'var(--fm-view-header-text)' }}>
                  {fileManagerTexts.name || "Name"}
                </Text>
              </GridItem>
              <GridItem colSpan={2} textAlign="center" display={{ base: 'none', md: 'block' }}>
                <Text fontWeight="bold" fontSize="sm" sx={{ color: 'var(--fm-view-header-text)' }}>
                  {fileManagerTexts.size || "Size"}
                </Text>
              </GridItem>
              <GridItem colSpan={2} textAlign="center" display={{ base: 'none', md: 'block' }}>
                <Text fontWeight="bold" fontSize="sm" sx={{ color: 'var(--fm-view-header-text)' }}>
                  {fileManagerTexts.lastModified || "Last Modified"}
                </Text>
              </GridItem>
              <GridItem colSpan={3} textAlign="end">
                <Text fontWeight="bold" fontSize="sm" sx={{ color: 'var(--fm-view-header-text)' }}>
                  {fileManagerTexts.actions || "Actions"}
                </Text>
              </GridItem>
            </Grid>
            <Box 
              overflowY={"auto"} 
              h={`calc(${Height.md} - 8rem)`} 
              sx={{ 
                '&::-webkit-scrollbar': { width: '6px' }, 
                '&::-webkit-scrollbar-track': { background: 'var(--fm-view-scrollbar-track)' }, 
                '&::-webkit-scrollbar-thumb': { background: 'var(--fm-view-scrollbar-thumb)', borderRadius: '24px' } 
              }}
            >
              {subFolders?.map(folder => (
                <Folder
                  key={folder.FolderId}
                  Item={folder}
                  OnChange={OnChange}
                  OnSelect={OnSelect}
                  OnSubmit={OnSubmitFolder}
                  texts={texts}
                />
              ))}
              {Files?.map(file => (
                <File
                  key={file.FileId}
                  Item={file}
                  OnChange={OnChange}
                  OnSubmit={OnSubmitFile}
                  texts={texts}
                />
              ))}
            </Box>
          </Box>
        ) : !haveContent && SelectedFolder ? (
          <Flex 
            h="calc(100% - 41px)" 
            align="center" 
            justify="center" 
            fontSize="lg" 
            sx={{ color: 'var(--fm-empty-text-color)' }}
          >
            {fileManagerTexts.thisFolderIsEmpty || "This folder is empty."}
          </Flex>
        ) : (
          <Flex 
            h="calc(100% - 41px)" 
            align="center" 
            justify="center" 
            fontSize="lg" 
            sx={{ color: 'var(--fm-empty-text-color)' }}
          >
            {fileManagerTexts.selectFolderToView || "Select a folder to view its contents"}
          </Flex>
        )}
      </Box>
    </Box>
  );
};

export default ViewManualReport;